import {NgModule} from '@angular/core';
import {ValidateSkuPipe} from './validate-tag/validate-sku';
import {ValidateRfidPipe} from './validate-tag/validate-rfid';
import {ValidateUpcPipe} from './validate-tag/validate-upc';
import {ValidateChangeStatusFieldPipe} from './validate-tag/validate-change-status-field';
import {ValidateAssociationFirstFieldPipe} from './validate-tag/validate-association-first-field';
import {ValidateAssociationSecondFieldPipe} from './validate-tag/validate-association-second-field';
import {PadUpcPipe} from './validate-tag/pad-upc';
import {PadSkuPipe} from './validate-tag/pad-sku';
import {PadRfidPipe} from './validate-tag/pad-rfid';
import {FormatDataTypePipe} from './format-data-type/format-data-type';
import {CycleCountColumnsPipe} from './cycle-count-columns/cycle-count-columns';
import {MapPipe} from './map/map';
import { ValidateInputPipe } from './validate-input/validate-input';

@NgModule({
  declarations: [ValidateSkuPipe,
    ValidateRfidPipe,
    ValidateUpcPipe,
    ValidateChangeStatusFieldPipe,
    ValidateAssociationFirstFieldPipe,
    ValidateAssociationSecondFieldPipe,
    PadUpcPipe,
    PadSkuPipe,
    PadRfidPipe,
    FormatDataTypePipe,
    CycleCountColumnsPipe,
    MapPipe,
    ValidateInputPipe],
  imports: [],
  exports: [ValidateSkuPipe,
    ValidateRfidPipe,
    ValidateUpcPipe,
    ValidateChangeStatusFieldPipe,
    ValidateAssociationFirstFieldPipe,
    ValidateAssociationSecondFieldPipe,
    PadUpcPipe,
    PadSkuPipe,
    PadRfidPipe,
    FormatDataTypePipe,
    CycleCountColumnsPipe,
    MapPipe,
    ValidateInputPipe],
  providers: [
    CycleCountColumnsPipe,
    MapPipe
  ]
})
export class PipesModule {
}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts